import Title from './title';

export default Title;
export { Title };